import { memo } from 'react';

function InstitutionsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 11.7542C14.8383 12.6292 12.4754 13.1111 10 13.1111C7.52457 13.1111 5.16167 12.6292 3 11.7542M13.1111 6.11111V4.55556C13.1111 3.69645 12.4147 3 11.5556 3H8.44444C7.58533 3 6.88889 3.69645 6.88889 4.55556V6.11111M10 10.7778H10.0078M4.55556 17H15.4444C16.3036 17 17 16.3036 17 15.4444V7.66667C17 6.80756 16.3036 6.11111 15.4444 6.11111H4.55556C3.69645 6.11111 3 6.80756 3 7.66667V15.4444C3 16.3036 3.69645 17 4.55556 17Z"
        stroke="#6B7280"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(InstitutionsIcon);
